import services from 'services/services';
import * as types from '../../types';

// Import helpers
import { checkFetchErrors } from '../../helpers_actions/convert_helpers';

// ******************** FETCH EPISODE TO EDIT ********************
export const fetchEpisode = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_EPISODE_LOADING,
			payload: true
		});

		const response = await services.get(`/vod/${id}`);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_EPISODE_SUCCESS,
			payload: response.data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_EPISODE_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
